import { header } from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import './Header.css'
import logo from '../images/logo.png'

const Header = () => {
  const { homepage, title } = header

  return (
    <header className='header center'>
      <img src={logo}  alt="logo"  />
      <h3>
        {homepage ? (
          <a href={homepage} className='link'>
            {title}
          </a>
        ) : (
          title
        )}
      </h3>
      <Navbar />
    </header>
  )
}

export default Header
